import { Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

const { Dragger } = Upload;

/**
 * Returns a form field config for a document upload Dragger with standard icon and text.
 * Used in pensioners additional/personal info fields.
 * @function
 *
 * @param {string} labelKey - Translation key for the field label (and key passed to getDraggerProps).
 * @param {function} getDraggerProps - Function(docKey) returning props for Dragger.
 * @param {function} t - Translation function.
 * @returns {Object} Field config { label, input }.
 */
export const createDocumentDraggerField = (labelKey, getDraggerProps, t) => ({
  label: labelKey,
  input: (
    <Dragger {...getDraggerProps(labelKey)}>
      <p className="ant-upload-drag-icon">
        <UploadOutlined style={{ color: 'var(--textColor)' }} />
      </p>
      <p className="ant-upload-text">{t('files.create.action')}</p>
    </Dragger>
  )
});

/**
 * Same as createDocumentDraggerField but for getDraggerProps(objectKey, docKey) (e.g. secondary profile).
 * @function
 *
 * @param {string} labelKey - Translation key for the field label.
 * @param {string} objectKey - First argument to getDraggerProps (e.g. 'secondary_profile').
 * @param {string} docKey - Second argument to getDraggerProps (e.g. 'secondary_profile_criminal_record_extract').
 * @param {function} getDraggerProps - Function(objectKey, docKey) returning props for Dragger.
 * @param {function} t - Translation function.
 * @returns {Object} Field config { label, input }.
 */
export const createDocumentDraggerFieldWithObject = (
  labelKey,
  objectKey,
  docKey,
  getDraggerProps,
  t
) => ({
  label: labelKey,
  input: (
    <Dragger {...getDraggerProps(objectKey, docKey)}>
      <p className="ant-upload-drag-icon">
        <UploadOutlined style={{ color: 'var(--textColor)' }} />
      </p>
      <p className="ant-upload-text">{t('files.create.action')}</p>
    </Dragger>
  )
});
